import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  user: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    register: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    updateUser: (state, action) => {
      state.user = action.payload.user;
    },
    exitUser: (state) => {
      state.token = "";
      state.user = null;
    },
  },
});

export const { register, updateUser, exitUser } = userSlice.actions;
export default userSlice.reducer;
